export const ACCOUNT_TYPE = {
   PATIENT : "Patient",
  DOCTOR: "Doctor",
   ADMIN: "Admin",
  }
  

  
  